'use strict';
export default '0.9.6';
